import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

import * as sessionUserSelector from 'selectors/sessionUser'
import {
  useFetchReleaseNotesQuery,
  useCreateReleaseNoteMutation,
} from 'api/releaseNotes'

import moment from 'moment-wrapper'
import MainWrap from 'components/Shared/Skeleton/MainWrap/Index'
import Header from 'components/Shared/Header/Index'
import Content from 'components/Shared/Skeleton/Content/Index'
import ReleasesListSidebar from '../ReleaseNotesPage/ReleasesListSidebar/Index'
import AddEditReleaseForm from '../ReleaseNotesPage/AddEditReleaseForm/Index'
import { RouteReleaseNotes } from 'routes'

const ReleaseNotesAddPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const { data, isFetching } = useFetchReleaseNotesQuery()
  const [createReleaseNote, { isLoading: isCreating }] = useCreateReleaseNoteMutation()

  const userIsAdmin = useSelector(sessionUserSelector.isAdmin)
  const canAddEdit = userIsAdmin

  const releaseNotes = data?.releaseNotes || []

  if (!canAddEdit) {
    navigate(RouteReleaseNotes())
    return
  }

  const onSubmit = (values) => {
    if (moment.isMoment(values.date)) {
      values.date = values.date.toISOString()
    }

    createReleaseNote({ params: values }).then(fulfilled => {
      if (!fulfilled.data?.error) {
        // switch to just created (last) release note
        navigate(RouteReleaseNotes())
      }
    })
  }

  const onSidebarReleaseNoteClick = (releaseNote) => {
    navigate(RouteReleaseNotes({ releaseNoteId: releaseNote.id }))
  }

  const onCloseForm = () => {
    navigate(RouteReleaseNotes())
  }

  const getBreadcrumbs = () => {
    const breadcrumbsList = [
      {
        text: t('common.breadcrumbReleaseNotes'),
        url: RouteReleaseNotes(),
      },
      {
        text: t('common.breadcrumbReleaseNotesAdd'),
      },
    ]
    return breadcrumbsList
  }

  return (
    <MainWrap pageTitle={t('releaseNotesPage.headerAdd')}>
      <ReleasesListSidebar
        releaseNotes={releaseNotes}
        onReleaseNoteClick={onSidebarReleaseNoteClick}
      />

      <Content loading={isFetching || isCreating}>
        <Header
          title={t('releaseNotesPage.headerAdd')}
          breadcrumbsList={getBreadcrumbs()}
        />

        <AddEditReleaseForm
          onSubmit={onSubmit}
          onCloseClick={onCloseForm}
        />
      </Content>
    </MainWrap>
  )
}

export default ReleaseNotesAddPage
